import AbstractProvidedClass from "../../../../shared/AbstractProvidedClass";
import { NEW_CUSTOM_LABEL } from "../../../../tools/actions/ActionHelper";

export default class NewLabelButton extends AbstractProvidedClass {
    constructor(provider, container, labelCollection, index, parentContainer) {
        super(provider);

        this.container = container;
        this.labelCollection = labelCollection;
        this.index = index;
        this.parentContainer = parentContainer;

        this.create();
    }

    create() {
        this.buttonContainer = this.p.createDiv()
            .style('height', '10px')
            .parent(this.container)
            .mouseOver(() => this.button.show())
            .mouseOut(() => this.button.hide());
        this.button = this.p.createButton('➕')
            .parent(this.buttonContainer)
            .style('position', 'relative')
            .style('top', '-10px')
            .style('left', '15px')
            .style('cursor', 'pointer')
            .attribute('data-tooltip', 'New label')
            .mouseClicked(() => this.actions.new(NEW_CUSTOM_LABEL, this.labelCollection, this.index, this.parentContainer));
        this.button.hide();
    }

    delete() {
        this.buttonContainer.remove();
    }

}
